<template>
    <main id="mainCtrl">
        <DoctorPaymentDataDialog ref="doctorPaymentDataDialog" @updated="updateTable"/>

        <v-table id="doctorPaymentDataTable"
                 request-uri="doctorPaymentData/getList"
                 pagesize="50"
                 ref="table">
            <template v-slot:header>
                <v-tr>
                    <v-th name="created_at" sort="created_at" width="100">
                        Дата
                    </v-th>
                    <v-th name="fullname" minwidth="150">
                        ФИО
                    </v-th>
                    <v-th name="url" sort="url" minwidth="100">
                        URL
                    </v-th>
                    <v-th name="status" sort="status" width="100">
                        Подтверждён
                    </v-th>
                    <v-th name="reject_reason" sort="reject_reason" width="100">
                        Причина отклонения
                    </v-th>
                    <v-th name="moderated_at" sort="moderated_at" width="100">
                        Дата проверки
                    </v-th>
                </v-tr>
                <v-tr>
                    <v-th name="created_at" v-slot="{filter}">
                        <date-piker v-model="filter.value"/>
                    </v-th>
                    <v-th name="fullname" :debounce="true" v-slot="{filter}">
                        <v-input v-model="filter.value"/>
                    </v-th>
                    <v-th name="url" v-slot="{filter}">
                        <v-input v-model="filter.value"/>
                    </v-th>
                    <v-th name="status" v-slot="{filter}">
                        <v-select
                            v-model="filter.value"
                            :options='[
                                ...v_s_convert(statuses)
                            ]'
                        />
                    </v-th>
                    <v-th name="reject_reason" :debounce="true" v-slot="{filter}">
                        <v-input v-model="filter.value"/>
                    </v-th>
                    <v-th name="moderated_at" v-slot="{filter}">
                        <date-piker v-model="filter.value"/>
                    </v-th>
                </v-tr>
            </template>
            <template v-slot:row="{ item, index }">
                <v-tr class="hover pointer"
                      :id="'dpd-tr-' + item.id"
                      @click="(row, event) => handleRowClick(event, item, row)"
                >
                    <v-td name="created_at"  highlight="*">
                        {{ item.created_at | formatDate }}
                    </v-td>
                    <v-td name="fullname">
                        {{ item.doctorUser.fullname }}
                    </v-td>
                    <v-td name="url">
                        {{ item.doctorUser.doctu_url }}
                    </v-td>
                    <v-td name="status" align="center">
                        <span :class="{'label bg-red' : item.status === 'NEW'}">
                            {{ statuses[item.status] }}
                        </span>
                    </v-td>
                    <v-td name="reject_reason">
                        {{ item.reject_reason }}
                    </v-td>
                    <v-td name="moderated_at"  highlight="*">
                        {{ item.moderated_at | formatDate }}
                    </v-td>
                </v-tr>
            </template>
        </v-table>
    </main>
</template>

<script>
import DoctorPaymentDataDialog from "@dialogs/admin/doctorPaymentData/DoctorPaymentDataDialog";

export default {
    components: {DoctorPaymentDataDialog},
    data: function () {
        return {
            statuses: {
                '': '',
                'NEW': 'Новый',
                'APPROVED': 'Подтвержден',
                'REJECTED': 'Отклонено',
            },
        };
    },
    methods: {
        handleRowClick(event, item, row) {
            row.startLoadingAnimation();

            this.$refs.doctorPaymentDataDialog.show(item.id)
                .then(() => row.stopLoadingAnimation())
                .catch(() => row.stopLoadingAnimation());
        },

        updateTable() {
            this.$refs.table.update();
            this.$bus.fire('updateMenu');
        }
    },
}
</script>
